import { Component, OnInit, Inject, Renderer2, DOCUMENT, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  standalone: true,
})
export class Footer implements OnInit {
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {}

  onSwitchMode(event: Event) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const isChecked = (event.target as HTMLInputElement).checked;
    const body = this.document.body;

    // Use Angular's Renderer2 for DOM manipulation
    if (isChecked) {
      this.renderer.addClass(body, 'dark');
    } else {
      this.renderer.removeClass(body, 'dark');
    }
  }
}
